import { inviteeFirstName } from '../lifetime-credits/gift-invite-welcome';

export type LeaveKind = 'stats' | 'reserve';

export type LeaveCopy = {
  title: string;
  lines: string[];
  action: string;
  path: string;
};

export function profileFirstName(displayName: string, channelName: string): string {
  return inviteeFirstName(displayName) || channelName;
}

export function profileSentence(
  about: string,
  displayName: string,
  channelName: string,
): string {
  const text = about.trim();
  if (text) return text;
  const name = profileFirstName(displayName, channelName);
  return `Welcome to ${name}'s QuickLinks page for QuickCam. QuickCam is the patented camera app ${name} is using to post to the social media platforms shown here.`;
}

export function giftLandingPath(channelName: string, giftCode: string): string {
  const channel = `/${encodeURIComponent(channelName)}`;
  if (giftCode) return `${channel}?giftcard=${encodeURIComponent(giftCode)}`;
  return `${channel}?giftcard=`;
}

export function leaveCopy(input: {
  kind: LeaveKind;
  displayName: string;
  channelName: string;
  giftCode: string;
}): LeaveCopy {
  const path = giftLandingPath(input.channelName, input.giftCode);
  if (input.kind === 'reserve') {
    return {
      title: 'Accept Gift Card',
      lines: [
        'Click "Confirm" to learn more about the QuickCam patented camera app and reserve a $25 Lifetime Access Gift Card.',
        'Offer is good while Gift Card supplies last.',
      ],
      action: 'Confirm',
      path,
    };
  }
  const name = profileFirstName(input.displayName, input.channelName);
  const lines = [`You must be a QuickCam member to view ${name}'s stats.`];
  if (input.giftCode) {
    lines.push(
      'Membership is free!',
      'Reserve a free $25 Lifetime Access Gift Card by clicking "Discover" to learn more about QuickCam patented camera app.',
      'Offer is good while Gift Card supplies last.',
    );
  } else {
    lines.push(
      'Membership is free! Click "Discover" to learn more about QuickCam patented camera app.',
    );
  }
  return {
    title: 'QuickCam Membership Required',
    lines,
    action: 'Discover',
    path,
  };
}
